"use client"
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Control, Controller, FieldErrors } from "react-hook-form";
import EditorPage from "../../EditorPage";
import { useDictionary } from "@/core/hooks/use-dictionary";


interface EditorWidgetProps {
    widgetIndex: number;
    name: string;
    control: Control<any>;
    errors: FieldErrors<any>;
    disabled?: boolean;
}

export const EditorWidget = ({
    widgetIndex,
    name,
    control,
    errors,
    disabled,
}: EditorWidgetProps) => {
    const { dictionary } = useDictionary();

    return (
        <div className="space-y-6 col-span-2">
            <Tabs defaultValue="fa" className="w-full">
                <TabsList className="border border-muted bg-primary-0">
                    <TabsTrigger value="fa" className="data-[state=active]:bg-muted">
                        {dictionary.ui?.language.fa}
                    </TabsTrigger>
                    <TabsTrigger value="en" className="data-[state=active]:bg-muted">
                        {dictionary.ui?.language.en}
                    </TabsTrigger>
                    <TabsTrigger value="ar" className="data-[state=active]:bg-muted">
                        {dictionary.ui?.language.ar}
                    </TabsTrigger>
                </TabsList>
                <TabsContent value="fa">
                    <Controller
                        control={control}
                        name={`${name}.${widgetIndex}.items.0.content`}
                        render={({ field }) => (
                            <EditorPage
                                value={field.value as string | undefined}
                                onChange={field.onChange}
                                error={
                                    (errors as any)?.[name]?.[widgetIndex]?.items?.[0]?.content?.message as string | undefined
                                }
                            />
                        )}
                    />
                </TabsContent>
                <TabsContent value="en">
                    <Controller
                        control={control}
                        // name="content_en"
                        name={`${name}.${widgetIndex}.items.0.content_en`}
                        render={({ field }) => (
                            <EditorPage
                                value={field.value as string | undefined}
                                onChange={field.onChange}
                                error={(errors as any)?.[name]?.[widgetIndex]?.items?.[0]?.content_en?.message as string | undefined}
                            />
                        )}
                    />
                </TabsContent>
                <TabsContent value="ar">
                    <Controller
                        control={control}
                        name={`${name}.${widgetIndex}.items.0.content_ar`}
                        render={({ field }) => (
                            <EditorPage
                                value={field.value as string | undefined}
                                onChange={field.onChange}
                                error={(errors as any)?.[name]?.[widgetIndex]?.items?.[0]?.content_ar?.message as string | undefined}
                            />
                        )}
                    />
                </TabsContent>
            </Tabs>
        </div>
    );
};
